export default __webpack_public_path__ + "static/media/menu-icon.2e227f09.svg";